import { makeStyles, Collapse, Typography } from '@paintscout/ui'
import React from 'react'
import { useQuote } from '../../context'
import type { WisetackPromoResponse } from '../types'

const useStyles = makeStyles((theme) => ({
  // Compliance (ENG-833): the disclosure MUST print. It was previously hidden in print
  // (`@media print { display: none }`), so the Estimate/Invoice PDFs showed the "as low as"
  // asterisk with no accompanying disclosure text — the 0-click violation Wisetack flagged.
  // It stays at the document footer (rendered via showWisetackDisclaimer in QuoteView), now
  // visible in print.
  root: {},
  text: {
    fontSize: theme.typography.pxToRem(12)
  }
}))

export default function WisetackPromoDisclaimer() {
  const { wisetackPromo } = useQuote()
  return (
    <Collapse show={!!wisetackPromo && !wisetackPromo.error}>
      <WisetackDisclaimerContent wisetackPromo={wisetackPromo} />
    </Collapse>
  )
}

export function WisetackDisclaimerContent({ wisetackPromo }: { wisetackPromo: WisetackPromoResponse }) {
  const classes = useStyles()
  function parseText(text: string) {
    if (!text) {
      return null
    }
    const words = text.split(' ')
    return words
      .map((word, i) => {
        const urlPattern = /^https?:\/\//i
        if (urlPattern.test(word)) {
          return (
            <a href={word} key={`word-${i}`} target="_blank" rel="noopener noreferrer">
              {word}
            </a>
          )
        } else {
          return word
        }
      })
      .reduce((prev, current, i) => {
        if (i === 0) {
          return [current]
        } else {
          return [...prev, ' ', current]
        }
      }, [] as JSX.Element[])
  }
  return (
    <div className={classes.root}>
      <Typography className={classes.text} align="left" variant="caption">
        {parseText(wisetackPromo?.disclosure)}
      </Typography>
    </div>
  )
}
